import { useEffect, useState } from "react";

import CrudListing from "components/crud/CrudListing";

import EmployeeModal from "./EmployeeModal";
import { employeeColumns } from "./columns";

import {
  getEmployees,
  deleteEmployee,
  importEmployees,
} from "services/api/employeeApi";

export default function Employees() {
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  // ============================================================
  // LOAD EMPLOYEES FOR EMPLOYEE DROPDOWN
  // ============================================================

  useEffect(() => {
    let mounted = true;

    const loadEmployeeOptions = async () => {
      try {
        setEmployeeLoading(true);

        const response = await getEmployees(1, 500);

        /*
         * Your employee API response may be:
         *
         * response.data.data.employees
         *
         * or
         *
         * response.data.employees
         */

        const employees =
          response?.data?.data?.employees ||
          response?.data?.employees ||
          [];

        if (!mounted) {
          return;
        }

        setEmployeeOptions(
          Array.isArray(employees)
            ? employees
            : []
        );
      } catch (error) {
        console.error(
          "Employee dropdown error:",
          error
        );

        if (mounted) {
          setEmployeeOptions([]);
        }
      } finally {
        if (mounted) {
          setEmployeeLoading(false);
        }
      }
    };

    loadEmployeeOptions();

    return () => {
      mounted = false;
    };
  }, []);

  // ============================================================
  // EMPLOYEE DROPDOWN OPTIONS
  // ============================================================

  const employeeFilterOptions =
    employeeOptions.map((employee) => ({
      value: String(employee.id),

      label:
        employee?.user?.name
          ? `${employee.user.name}${
              employee.employeeCode
                ? ` (${employee.employeeCode})`
                : ""
            }`
          : employee.employeeCode ||
            `Employee #${employee.id}`,
    }));

  // ============================================================
  // FILTERS
  // ============================================================

  const filters = [
    // ----------------------------------------------------------
    // EMPLOYEE
    // ----------------------------------------------------------

    {
      key: "employeeId",
      label: "Employee",
      type: "select",
      searchable: true,
      placeholder: employeeLoading
        ? "Loading employees..."
        : "All Employees",

      options: employeeFilterOptions,
    },

    // ----------------------------------------------------------
    // STATUS
    // ----------------------------------------------------------

    {
      key: "status",

      label: "Status",

      type: "select",

      placeholder: "All Status",

      options: [
        {
          value: "active",
          label: "Active",
        },

        {
          value: "inactive",
          label: "Inactive",
        },

        {
          value: "probition",
          label: "Probation Period",
        },

        {
          value: "resigned",
          label: "Resigned",
        },

        {
          value: "terminated",
          label: "Terminated",
        },
      ],
    },

    // ----------------------------------------------------------
    // JOINING DATE FROM
    // ----------------------------------------------------------

    {
      key: "joiningDateFrom",

      label: "Joining From",

      type: "date",
    },

    // ----------------------------------------------------------
    // JOINING DATE TO
    // ----------------------------------------------------------

    {
      key: "joiningDateTo",

      label: "Joining To",

      type: "date",
    },
  ];

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <CrudListing
      title="Employees"
      columns={employeeColumns}
      Modal={EmployeeModal}

      // Existing fetchData unchanged
      fetchData={async (page, limit, search, filters) => {
        const response = await getEmployees(
          page,
          limit,
          search,
          filters
        );

        const employees =
          response?.data?.data?.employees ||
          response?.data?.employees ||
          response?.data?.data?.records ||
          response?.data?.records ||
          [];

        const pagination =
          response?.data?.data?.pagination ||
          response?.data?.pagination ||
          {};

        return {
          data: {
            data: {
              records: Array.isArray(employees) ? employees : [],
              pagination,
            },
          },
        };
      }}

      deleteData={deleteEmployee}
      responseDataKey="records"
      showSearch={true}
      filters={filters}
      addButtonText="Add Employee"

      // New: Employee bulk import
      importData={importEmployees}
      importAccept=".csv,.xlsx,.xls"
    />
  );
}